import { z } from 'zod';

import defaultProductImage from '~/assets/images/marketing/default-product-image.svg';
import type { ProductMedia } from '~/hooks/useGetProduct';
import { type ProductImages, ProductImagesSchema } from '~/types/product';

export const safeRenderProductImage = (productImages: Array<ProductImages> | undefined): string => {
  const images = z.array(ProductImagesSchema).safeParse(productImages);

  if (!images.success) {
    return defaultProductImage;
  }

  try {
    return images.data?.[0]?.square || images?.data?.[0]?.thumbnail || defaultProductImage;
  } catch {
    return defaultProductImage;
  }
};

const ProductImagesApiSchema = z
  .object({
    square: z.object({
      type: z.string(),
      value: z.string(),
    }),
    thumbnail: z.object({
      type: z.string(),
      value: z.string(),
    }),
  })
  .nullish();

export const safeRenderProductImageApi = (productImages: ProductMedia): string => {
  const images = ProductImagesApiSchema.safeParse(productImages);

  if (!images.success) {
    return defaultProductImage;
  }

  if (images.data?.square) return images.data.square.value;
  if (images.data?.thumbnail) return images.data.thumbnail.value;

  return defaultProductImage;
};
